// see tes/resources#2294 TODO get rid of this
if (window.document.cookie.match(/siteCountry=US/) && window.location.pathname.match(/^\/teaching-resources\/?$/)) {
  window.location.href = '/';
}

var TESNAV = TESNAV || {};

function updateCookie(newValue, oldValue) {
  window.Cookies.set('siteCountry', newValue, {expires: 63072000, domain: window.document.domain.replace('www.','.')});
  if (window.TES.onSiteCountryChanged) {
    window.TES.onSiteCountryChanged(newValue, oldValue);
  } else {
    document.location.reload();
  }
}

TESNAV.siteCountry = function() {
  var $siteCountrySelect = jQuery('.siteCountry select');
  if (!$siteCountrySelect.length) { return; }
  var siteCountry = window.Cookies.get('siteCountry');
  $siteCountrySelect.val(siteCountry);
  $siteCountrySelect.on('change', function() {
    var newValue = this.value;
    if (siteCountry === newValue) return;
    var TESCookieV2 = window.Cookies.get('TESCookieV2');
    if (!window.Cookies.get('TESCookieUser') || !TESCookieV2) {
      updateCookie(newValue, siteCountry);
      return;
    }

    var url = TES.appAuthnApiUrl + '/change-site-country';

    jQuery.ajax(url, {
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        headers: { 'X-TslAuthJwt': TESCookieV2, 'X-CSRF-Token': window.Cookies.get('csrf') },
        data: JSON.stringify({ siteCountry: newValue }),
        success: function() {
          updateCookie(newValue, siteCountry);
        },
        error: function() {
          $siteCountrySelect.val(siteCountry);
          window.alert('There was an error. Please log in and try again.');
        }
      }
    );
  });
};
